import { setBodyClass } from '../helper/helpers';

export default class Nav {
  constructor() {
    this.isOpen = false;
    this.subItemOpen = null;
    this.subItemOpenItems = null;

    const header = document.querySelector('.header');

    if (!header) {
      return;
    }

    const burger = header.querySelector('.header__burger');
    const content = header.querySelector('.header__nav');
    const subToggles = header.querySelectorAll('.header__sub-toggle');

    if (!burger || !content) {
      return;
    }

    burger.addEventListener('click', () => this.toggleNav(burger, content));

    subToggles.forEach((subToggle) => {
      const item = subToggle.closest('.header__item');
      const subItems = item.querySelector('.header__sub-items');

      subToggle.addEventListener('click', () => this.toggleSub(item, subItems));
    });
  }

  /**
   * Handles clicks outside of the currently open sub-navigation.
   * Closes the sub-navigation if the click target is not within the open sub-navigation.
   * @param {MouseEvent} event - The click event.
   */
  handleClickOutside = (event) => {
    if (this.subItemOpen && !this.subItemOpen.contains(event.target)) {
      this.closeSub(this.subItemOpen, this.subItemOpenItems);
      this.subItemOpen = null;
      this.subItemOpenItems = null;
    }
  };

  /**
   * Handles keydown events to close the sub-navigation when the Escape key is pressed.
   * @param {KeyboardEvent} event - The keydown event.
   */
  handleKeyDown = (event) => {
    if (event.key === 'Escape' && this.subItemOpen) {
      this.closeSub(this.subItemOpen, this.subItemOpenItems);
      this.subItemOpen = null;
      this.subItemOpenItems = null;
    }
  };

  /**
   * Toggles the mobile navigation.
   * @param {Element} burger
   * @param {Element} content
   */
  toggleNav = (burger, content) => {
    if (this.isOpen) {
      this.isOpen = false;
      burger.classList.remove('is-open');
      content.classList.remove('is-open');

      setBodyClass('is-nav-open', false);
    } else {
      this.isOpen = true;
      burger.classList.add('is-open');
      content.classList.add('is-open');

      setBodyClass('is-nav-open', true);
    }
  };

  /**
   * Toggles the subnavigation of a main nav item.
   * @param {Element} item
   * @param {Element} subItems
   */
  toggleSub = (item, subItems) => {
    if (item.classList.contains('sub-open')) {
      this.closeSub(item, subItems);
    } else {
      if (this.subItemOpen) {
        this.closeSub(this.subItemOpen, this.subItemOpenItems);
      }

      this.subItemOpen = item;
      this.subItemOpenItems = subItems;

      item.classList.add('sub-open');
      subItems.style.maxHeight = `${subItems.scrollHeight}px`;

      document.addEventListener('click', this.handleClickOutside);
      document.addEventListener('keydown', this.handleKeyDown);
    }
  };

  /**
   * Closes the subnavigation item.
   * @param {Element} item
   * @param {Element} subItems
   */
  closeSub = (item, subItems) => {
    item.classList.remove('sub-open');
    subItems.style.maxHeight = 0;

    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);

    this.subItemOpen = null;
    this.subItemOpenItems = null;
  };
}
